
// @ts-nocheck
import locale__usr_src_app_client_locales_languages_ru_js from "../client/locales/languages/ru.js?hash=e80d6b44&locale=ru";


export const localeCodes =  [
  "ru"
]

export const localeLoaders = {
  "ru": [{ key: "../client/locales/languages/ru.js", load: () => Promise.resolve(locale__usr_src_app_client_locales_languages_ru_js), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../client/locales/vue-i18n.js?hash=a6023a0e&config=1" /* webpackChunkName: "client_locales_vue_i18n_js_a6023a0e" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "client/locales/vue-i18n.js",
  "locales": [
    {
      "code": "ru",
      "iso": "ru-RU",
      "dir": "ltr",
      "lang": "русский",
      "dayjsLocale": "ru",
      "name": "Россия",
      "country": "ru",
      "storeId": "ru",
      "languageCode": {
        "ru": "ru_RU"
      },
      "currencySymbol": "₽",
      "currencyCode": "RUB",
      "baseUrl": "https://goldapple.ru",
      "files": [
        "locales/languages/ru.js"
      ]
    }
  ],
  "defaultLocale": "ru",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "locales/languages",
  "detectBrowserLanguage": {
    "alwaysRedirect": true,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "ga-lang",
    "cookieSecure": false,
    "fallbackLocale": "",
    "redirectOn": "all",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "https://goldapple.ru",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": true,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "ru",
    "iso": "ru-RU",
    "dir": "ltr",
    "lang": "русский",
    "dayjsLocale": "ru",
    "name": "Россия",
    "country": "ru",
    "storeId": "ru",
    "languageCode": {
      "ru": "ru_RU"
    },
    "currencySymbol": "₽",
    "currencyCode": "RUB",
    "baseUrl": "https://goldapple.ru",
    "files": [
      {
        "path": "locales/languages/ru.js"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
